module.exports = __webpack_public_path__ + "static/media/path.79e57cbe.svg";